import { Collapse } from 'react-collapse';
import DomainHeader from './DomainHeader';
import React from 'react';
import Segment from '../Segment';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  .ReactCollapse--collapse {
    transition: height 250ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .ReactCollapse--content {
    display: flex;
    flex-direction: column;
  }
  ${({ $active }) => $active &&
    css `
      cursor: pointer;
    `}
`;
const DomainSegment = ({ children, active, onClick, title, }) => {
    return (React.createElement(Wrapper, { onClick: !active ? onClick : void 0, "$active": !active },
        React.createElement(Segment, { raised: true, paddingSize: "l" },
            React.createElement(DomainHeader, { active: active }, title),
            React.createElement(Collapse, { isOpened: active },
                React.createElement(React.Fragment, null, children)))));
};
export default DomainSegment;
